// Check if the form is visible in the viewport
function isFormVisible(formId) {
	var form = document.getElementById(formId);
	var rect = form.getBoundingClientRect();
	var windowHeight = window.innerHeight || document.documentElement.clientHeight;
	return rect.top <= windowHeight && rect.bottom >= 0;
  }
  
// Load the script when the form is visible
function loadScriptFormVisible(scriptUrl, formId) {

	if (isFormVisible(formId)) {

	  var script = document.createElement("script");
	  script.src = scriptUrl; // Use the provided script URL
	  script.async = true;

	  document.head.appendChild(script);
  
	  // Remove the event listener once the script is loaded
	  window.removeEventListener("scroll", handleScroll);
	  
	}
}  
function handleScroll() { 
	loadScriptFormVisible('https://sibforms.com/forms/end-form/build/main.js','sib-form'); 
}
window.onload = function() {
    window.addEventListener('scroll', handleScroll);
};